import store from '../src/store/store';

export default class PopupProvider {
  static setIsActive(active) {
    store.commit('POPUP/setIsActive', active);

    return this;
  }


  static setTitle(title) {
    store.commit('POPUP/setTitle', title);

    return this;
  }


  static setContent(content) {
    store.commit('POPUP/setContent', content);

    return this;
  }


  static setPopupClasses(classes) {
    store.commit('POPUP/setPopupClasses', classes);

    return this;
  }

  static setFullscreen(fullscreen) {
    store.commit('POPUP/setFullscreen', fullscreen);

    return this;
  }


  static clearPopup() {
    this.setIsActive(false);
    this.setContent(null);
    this.setTitle('');
    this.setPopupClasses('');
    this.setFullscreen(false);
  }
}
